"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findArchiveListBasedOnSearch = exports.deleteArchiveByArchiveId = exports.deleteArchivExportReset = exports.archiveExportSuccess = exports.archiveExportError = void 0;
var _archiveExport = require("./archiveExport.constant");
// common success
var archiveExportSuccess = function archiveExportSuccess(actionType, data) {
  return {
    type: _archiveExport.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.archiveExportSuccess = archiveExportSuccess;
var archiveExportError = function archiveExportError(actionType, error) {
  return {
    type: _archiveExport.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * find archive list based on search
 * @param payload
 * @returns api response
 * @description this function used to see the arichive list.
 */
exports.archiveExportError = archiveExportError;
var findArchiveListBasedOnSearch = function findArchiveListBasedOnSearch(data) {
  return {
    type: _archiveExport.actionTypes.FINDS_ARCHIVE_LIST_BASED_SEARCH_PARAMS,
    payload: data
  };
};

/**
 * delete archive by archive Id
 * @param payload
 * @returns api response
 * @description this function used to delete archive list
 */
exports.findArchiveListBasedOnSearch = findArchiveListBasedOnSearch;
var deleteArchiveByArchiveId = function deleteArchiveByArchiveId(data) {
  return {
    type: _archiveExport.actionTypes.DELETE_ARCHIVE_BY_ARCHIVE_ID,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset the archiv list
 */
exports.deleteArchiveByArchiveId = deleteArchiveByArchiveId;
var deleteArchivExportReset = function deleteArchivExportReset() {
  return {
    type: _archiveExport.actionTypes.EXPORT_RESET
  };
};
exports.deleteArchivExportReset = deleteArchivExportReset;